import Axios from 'axios'

const API = {
  options: {
    search: ''
  },
  search(data) {
    return (window.location.hostname === 'localhost' ? Axios.get(this.options.search, data) : Axios.post(this.options.search, data)).then((response) => {
      return response.data
    }).catch((error) => {
      console.error('API.search()', error)
    })
  }
}

export default API
